 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React, {useMemo, useState} from 'react'
import {useFragment} from 'react-relay'
import useSpotlightResults from '~/hooks/useSpotlightResults'
import useDraggableReflectionCard from '../../hooks/useDraggableReflectionCard'





import ReflectionCard from '../ReflectionCard/ReflectionCard'








const makeDragState = () => ({
  id: '',
  cardOffsetX: 0,
  cardOffsetY: 0,
  clientY: 0, // used for scrollZone
  clone: null ,
  isDrag: false,
  longpressed: null ,
  longpressTimeout: undefined ,
  ref: null ,
  startX: 0,
  startY: 0,
  wasDropping: false,
  targets: [] ,
  prevTargetId: '',
  isBroadcasting: false,
  dropZoneEl: null ,
  // dropZoneId: '',
  dropZoneBBox: null ,
  timeout: null 
})

const DragWrapper = styled('div')(({showDragCursor}) => ({
  cursor: showDragCursor ? 'grab' : undefined
}))

 























const DraggableReflectionCard = (props) => {
  const {
    isClipped,
    reflection: reflectionRef,
    staticIdx = 0,
    staticReflections: staticReflectionsRef,
    meeting: meetingRef,
    openSpotlight,
    isDraggable,
    swipeColumn,
    dataCy,
    isSpotlightEntering,
    showDragHintAnimation
  } = props
  const staticReflections = useFragment(
    graphql`
      fragment DraggableReflectionCard_staticReflections on RetroReflection @relay(plural: true) {
        id
        reflectionGroupId
      }
    `,
    staticReflectionsRef
  )
  const reflection = useFragment(
    graphql`
      fragment DraggableReflectionCard_reflection on RetroReflection {
        ...ReflectionCard_reflection
        ...RemoteReflection_reflection
        id
        isEditing
        promptId
        isViewerDragging
        isViewerCreator
        isDropping
        reflectionGroupId
        remoteDrag {
          dragUserId
          dragUserName
          isSpotlight
          targetId
        }
      }
    `,
    reflectionRef
  )
  const meeting = useFragment(
    graphql`
      fragment DraggableReflectionCard_meeting on RetrospectiveMeeting {
        ...ReflectionCard_meeting
        ...RemoteReflection_meeting
        ...useSpotlightResults_meeting
        id
        teamId
        localStage {
          isComplete
          phaseType
        }
        phases {
          stages {
            isComplete
            phaseType
          }
        }
        spotlightGroup {
          id
        }
        spotlightReflectionId
        spotlightSearchQuery
      }
    `,
    meetingRef
  )
  const {teamId, localStage, spotlightGroup, spotlightReflectionId} = meeting
  const {isComplete, phaseType} = localStage
  const {id: reflectionId, isDropping, isEditing, remoteDrag} = reflection
  const spotlightGroupId = _optionalChain([spotlightGroup, 'optionalAccess', _ => _.id])
  const isSpotlightOpen = !!spotlightGroupId
  const isInSpotlight = !openSpotlight
  const staticReflectionCount = _optionalChain([staticReflections, 'optionalAccess', _2 => _2.length]) || 0
  const [drag] = useState(makeDragState)
  const spotlightResultGroups = useSpotlightResults(meeting)
  const isReflectionIdInSpotlight = useMemo(() => {
    return (
      reflectionId === spotlightReflectionId ||
      !!(
        reflectionId &&
        _optionalChain([spotlightResultGroups, 'optionalAccess', _3 => _3.find, 'call', _4 => _4(({reflections}) =>
          _optionalChain([reflections, 'optionalAccess', _5 => _5.find, 'call', _6 => _6(({id}) => id === reflectionId)])
        )])
      )
    )
  }, [spotlightResultGroups, reflectionId, spotlightReflectionId])
  const {onMouseDown} = useDraggableReflectionCard(
    meeting,
    reflection,
    drag,
    staticIdx,
    teamId,
    staticReflectionCount,
    swipeColumn
  )
  const canHandleDrag = phaseType === 'group' && !isComplete && isDraggable
  const showDragCursor = isDraggable && canHandleDrag && !isEditing && !isDropping
  // slow state updates can mean we miss an onMouseDown event
  const handleDrag = canHandleDrag ? onMouseDown : undefined

  return (
    React.createElement(DragWrapper, {
      ref: (c) => {
        // If the spotlight is closed, this card is the single source of truth
        // Else, if it's a remote drag that is not in the spotlight
        // Else, if this is the instance in the source or search results
        // And Spotlight modal isn't entering. This throws off dropping remote card position
        const isPriorityCard =
          (!isSpotlightOpen || (!isReflectionIdInSpotlight && remoteDrag) || isInSpotlight) &&
          !isSpotlightEntering
        if (isPriorityCard) {
          drag.ref = c
        }
      },
      onMouseDown: handleDrag,
      onTouchStart: handleDrag,
      showDragCursor: showDragCursor,}

      , React.createElement(ReflectionCard, {
        dataCy: dataCy,
        reflectionRef: reflection,
        isClipped: isClipped,
        meetingRef: meeting,
        openSpotlight: openSpotlight,
        showDragHintAnimation: showDragHintAnimation,}
      )
    )
  )
}

export default DraggableReflectionCard
